import { createSelector } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { CashflowCustomModelTypeEnum } from "api/admin/src";
import { concatRates } from "components/pages/administration/cashflow-forecast/ins-cashflow-common-functions";
const defaultCommitment = 10000000;
export const useGetTaModelCommitment = (id) => useSelector((state) => state.administration.cashflowForecastingState
    .taModelEditingState.model[id]?.present?.parameters?.commitment) ?? defaultCommitment;
const currentTaCustomModelSelector = createSelector((state, id) => state.administration?.cashflowForecastingState?.taModelEditingState?.model[id]?.present, (state, id) => state.entities.CashflowCustomModel[id], (edited, initial) => {
    const contributionRates = edited?.changes?.contributionRates ??
        concatRates(initial?.taParameters?.contributionRates, initial?.taParameters?.terminal);
    return {
        asOfDate: edited?.changes?.asOfDate ?? initial?.asOfDate,
        commitment: edited?.changes?.commitment ?? initial?.commitment,
        description: edited?.changes?.description ?? initial?.description,
        name: edited?.changes?.name ?? initial?.name,
        taParameters: {
            bow: edited?.changes?.bow ?? initial?.taParameters?.bow,
            contributionRates: contributionRates?.slice(0, contributionRates?.length - 1 || 0),
            growthRate: edited?.changes?.growthRate ?? initial?.taParameters?.growthRate,
            lifetime: edited?.changes?.lifetime ?? initial?.taParameters?.lifetime,
            minDistributionRate: edited?.changes?.minDistributionRate ?? initial?.taParameters?.minDistributionRate,
            terminal: contributionRates?.[contributionRates?.length - 1 || 0]
        },
        type: CashflowCustomModelTypeEnum.TaParameters
    };
});
export const useGetCurrentTaCustomModel = (id) => useSelector((s) => currentTaCustomModelSelector(s, id), isEqual);
